import { useCallback, useEffect, useState } from "react";

export default function useResizeObserver(onResize) {
    const [node, setNode] = useState(null);

    useEffect(() => {
        if (!node) {
            return undefined;
        }

        const observer = new ResizeObserver((entries) => {
            const entry = entries?.[0];
            if (!entry) {
                return;
            }

            onResize?.(entry);
        });

        observer.observe(node);

        return () => {
            observer.disconnect();
        };
    }, [node, onResize]);

    const ref = useCallback((element) => {
        setNode(element);
    }, []);

    return ref;
}

